import { getStore } from '../../../../../init-store';
import { selectIsUseFedyaPreloaderEnabled } from '../../flags/selectors';
import { fedyaModuleFederation, moduleFederation } from '../module-federation';

export const getModuleFederation = () => {
    const state = getStore().getState();
    const isUseFedyaPreloaderEnabled = selectIsUseFedyaPreloaderEnabled(state);
    return isUseFedyaPreloaderEnabled ? fedyaModuleFederation : moduleFederation;
};
